import React, { useState } from "react";
import { Link, navigate } from "gatsby";
import { Button, Collapse, Divider, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, styled, Typography } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import AccountCircle from '@mui/icons-material/AccountCircle';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { actions } from "../services/wallet";


const Root = styled('div')({

});

const EthIcon: React.FC<{ size: number }> = ({ size }) => {
  return (
    <svg fill="#CCC" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width={`${size}px`} height={`${size}px`}>    <path d="M 25 1 C 24.67 1 24.392938 1.1690625 24.210938 1.4140625 C 24.195937 1.4340625 24.17025 1.4408906 24.15625 1.4628906 L 10.15625 23.462891 C 10.13925 23.488891 10.137047 23.521828 10.123047 23.548828 C 10.091047 23.611828 10.069781 23.674188 10.050781 23.742188 C 10.034781 23.801188 10.020625 23.858922 10.015625 23.919922 C 10.010625 23.987922 10.016391 24.053047 10.025391 24.123047 C 10.030391 24.162047 10.019297 24.202234 10.029297 24.240234 C 10.036297 24.267234 10.055453 24.288453 10.064453 24.314453 C 10.073453 24.340453 10.070031 24.368531 10.082031 24.394531 C 10.099031 24.433531 10.129391 24.458141 10.150391 24.494141 C 10.183391 24.551141 10.217719 24.605297 10.261719 24.654297 C 10.309719 24.708297 10.362922 24.752922 10.419922 24.794922 C 10.450922 24.817922 10.470906 24.850141 10.503906 24.869141 L 24.503906 32.869141 C 24.525906 32.882141 24.551219 32.887438 24.574219 32.898438 C 24.601219 32.911437 24.62725 32.920641 24.65625 32.931641 C 24.76725 32.971641 24.883 33 25 33 C 25.117 33 25.23275 32.972641 25.34375 32.931641 C 25.37275 32.920641 25.397781 32.909484 25.425781 32.896484 C 25.448781 32.885484 25.474094 32.880188 25.496094 32.867188 L 39.496094 24.867188 C 39.502094 24.863187 39.505719 24.856516 39.511719 24.853516 C 39.613719 24.792516 39.703297 24.714141 39.779297 24.619141 C 39.797297 24.596141 39.809172 24.569922 39.826172 24.544922 C 39.859172 24.495922 39.895922 24.450531 39.919922 24.394531 C 39.930922 24.368531 39.926547 24.341453 39.935547 24.314453 C 39.944547 24.288453 39.963703 24.267234 39.970703 24.240234 C 39.979703 24.202234 39.971562 24.162047 39.976562 24.123047 C 39.985563 24.053047 39.990375 23.986969 39.984375 23.917969 C 39.979375 23.856969 39.965219 23.799234 39.949219 23.740234 C 39.930219 23.672234 39.909953 23.609875 39.876953 23.546875 C 39.862953 23.519875 39.85975 23.488891 39.84375 23.462891 L 25.84375 1.4628906 C 25.83075 1.4418906 25.804063 1.4330625 25.789062 1.4140625 C 25.607062 1.1690625 25.33 1 25 1 z M 25 3.5625 L 25 19 L 36.761719 24.128906 L 25 31 L 25 19 L 12.5625 23.3125 L 25 3.5625 z M 10.839844 28.013672 C 10.619469 28.049422 10.411406 28.159937 10.253906 28.335938 C 9.9399062 28.688938 9.9153125 29.21375 10.195312 29.59375 L 24.195312 48.59375 C 24.208313 48.61075 24.229188 48.616813 24.242188 48.632812 C 24.309188 48.713813 24.389516 48.776031 24.478516 48.832031 C 24.512516 48.854031 24.539172 48.881437 24.576172 48.898438 C 24.706172 48.959437 24.847 49 25 49 C 25.153 49 25.293828 48.959437 25.423828 48.898438 C 25.459828 48.881437 25.487484 48.853031 25.521484 48.832031 C 25.610484 48.776031 25.690812 48.713813 25.757812 48.632812 C 25.770813 48.616813 25.792688 48.61075 25.804688 48.59375 L 39.804688 29.59375 C 40.084688 29.21375 40.061094 28.688937 39.746094 28.335938 C 39.432094 27.981938 38.912906 27.898813 38.503906 28.132812 L 25 35.849609 L 11.496094 28.132812 C 11.292094 28.016813 11.060219 27.977922 10.839844 28.013672 z M 14.611328 32.216797 L 25 38.3125 L 25 46.126953 L 14.611328 32.216797 z" /></svg>
  )
}

export const WalletDropdown: React.FC = () => {
  const wallet = useSelector((state: RootState) => state.wallet);
  const dispatch = useDispatch();

  const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const disconnect = () => {
    navigate('/');
    setAnchorEl(null);
    dispatch(actions.disconnectWallet());
  }

  const connect = () => {
    dispatch(actions.connectWallet({}));
  }

  if (!wallet.account) {
    return <Button variant="text" color="inherit" onClick={connect}>Connect</Button>;
  }


  return (
    <Root>
      <IconButton
        size="large"
        aria-label="account of current wallet"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} sx={{ maxWidth: 250 }} disabled>
          <EthIcon size={40} />
          <Typography noWrap>
            {wallet.account}
          </Typography>
        </MenuItem>
        <Divider />
        {
          process.env.GATSBY_SALE_MODE !== 'coming_soon' ? (
            <MenuItem component={Link} to="/user/my-hayapes">My HayApe's</MenuItem>
          ) : null
        }
        {
          process.env.GATSBY_SALE_MODE !== 'coming_soon' ? (
            <Divider />
          ) : null
        }
        <MenuItem onClick={disconnect}>Disconnect</MenuItem>
      </Menu>
    </Root>
  );
};




export const WalletListItem: React.FC = () => {
  const wallet = useSelector((state: RootState) => state.wallet);
  const dispatch = useDispatch();

  const [ open, setOpen ] = useState(true);

  const disconnect = () => {
    navigate('/');
    dispatch(actions.disconnectWallet());
  }

  const connect = () => {
    dispatch(actions.connectWallet({}));
  }

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <React.Fragment>
      {
        !wallet.account ? (
          <ListItemButton onClick={connect}>
            <ListItemText primary="Connect" />
          </ListItemButton>
        ) : null
      }

      {
        wallet.account ? (
          <React.Fragment>
            <ListItemButton onClick={handleClick} >
              <ListItemIcon>
                <EthIcon size={25} />
              </ListItemIcon>
              <ListItemText primary={wallet.account} primaryTypographyProps={{ noWrap: true }} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {
                  process.env.GATSBY_SALE_MODE !== 'coming_soon' ? (
                    <ListItemButton sx={{ pl: 4 }} component={Link} to="/user/my-hayapes" onClick={handleClick}>
                      <ListItemText primary="My HayApe's" />
                    </ListItemButton>
                  ) : null
                }

                <ListItemButton sx={{ pl: 4 }} onClick={disconnect}>
                  <ListItemText primary="Disconnect" />
                </ListItemButton>
              </List>
            </Collapse>
          </React.Fragment>
        ) : null
      }


    </React.Fragment>
  )
}